import Api from '@/services/ApiService';

const state = {
    config: null,
    loading: false
};

const mutations = {
    SET_CONFIG(state, config) {
        state.config = config;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    }
};

const actions = {
    async loadConfig({ commit, state }) {
        if (state.config) return state.config;
        
        commit('SET_LOADING', true);
        try {
            const { data } = await Api().get('/tenants/config');
            commit('SET_CONFIG', data);
            
            if (data.primaryColor) {
                document.documentElement.style.setProperty('--primary-color', data.primaryColor);
            }
            if (data.secondaryColor) {
                document.documentElement.style.setProperty('--secondary-color', data.secondaryColor);
            }
            if (data.favicon) {
                let link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.head.appendChild(link);
                }
                link.href = data.favicon;
            }
            
            return data;
        } catch (error) {
            console.error('Erro ao carregar configurações do tenant:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    }
};

const getters = {
    tenantConfig: state => state.config,
    tenantLoading: state => state.loading,
    tenantLogo: state => state.config?.logo,
    tenantFavicon: state => state.config?.favicon,
    tenantPrimaryColor: state => state.config?.primaryColor,
    tenantSecondaryColor: state => state.config?.secondaryColor,
    featureFlags: state => state.config?.feature_flags || {},
    getFeatureFlag: state => (flagName) => state.config?.feature_flags?.[flagName] || false,
    featureFlagsAdm: state => state.config?.feature_flags_adm || {},
    getFeatureFlagAdm: state => (flagName) => {
        const flags = state.config?.feature_flags_adm || {};
        if (flags[flagName] !== undefined) {
            return flags[flagName];
        }
        return true;
    },
    getVisibleRoutes: state => (routeKey) => {
        const flags = state.config?.feature_flags_adm || {};
        const visibleRoutes = flags.visible_routes || null;
        if (!visibleRoutes) return true;
        return visibleRoutes.includes(routeKey);
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};
